export default __webpack_public_path__ + "static/media/ThinDesign.6f40af57.woff2";